export const calculateEMI = (principal, annualRate, tenureMonths) => {
  console.log("🔍 EMI Calculation Debug:");
  console.log("➡️ Principal:", principal);
  console.log("➡️ Annual Rate (%):", annualRate);
  console.log("➡️ Tenure (months):", tenureMonths);

  if (!principal || !annualRate || !tenureMonths) {
    console.warn("⚠️ Missing input(s). Returning null.");
    return null;
  }

  const r = (annualRate / 12) / 100;
  console.log("➡️ Monthly Rate (decimal):", r);

  const n = tenureMonths;
  const onePlusRPowerN = Math.pow(1 + r, n);
  console.log("➡️ (1 + r)^n:", onePlusRPowerN);

  const numerator = principal * r * onePlusRPowerN;
  const denominator = onePlusRPowerN - 1;

  console.log("➡️ Numerator:", numerator);
  console.log("➡️ Denominator:", denominator);

  if (denominator === 0) {
    console.error("💥 Denominator is zero. Invalid calculation.");
    return null;
  }

  const emi = numerator / denominator;
  console.log("✅ Final EMI (rounded):", Math.round(emi));

  return Math.round(emi);
};